import { View } from "@/components/ui/view";
import React, { useContext } from 'react';
import OutputHandle from "../basic/OutputHandle";
import NodeView from "./NodeView";
import { MediaContext } from "../media/MediaContext";
import { IconM } from '@/components/media/IconsV2';

export default function WorkflowStartNode({ id, data, selected }) {
    const { flowId, nodeHighlighting } = useContext(MediaContext)

    return (
        <NodeView id={id} data={data} selected={selected} disabled={flowId == 'showFlow'} nodeHighlighting={nodeHighlighting[id]}>
            <View className="absolute -left-[52px] top-0 bg-primary-900 border border-primary-900 rounded-[4px] p-1">
                <IconM className='text-primary-50' size={36} name='rocket-launch' />
            </View>
            <OutputHandle id='output' position={28} nodeHighlighting={nodeHighlighting[id]} />
        </NodeView>
    );
}